/** The logo will fallback to mobile if desktop is not provided. */
export type ElectionLogo = {
    /** An image uri. */
    mobile: string
    /** An image uri. */
    desktop?: string
}

export type BaseElection = {
    year: number
    logo: ElectionLogo
    meta: {
        title?: string
        description?: string
        /** A 1200x630px image uri. */
        socialImage: string
    }
}

export type StateElection = {
    type: 'state'
    state: 'act' | 'nsw' | 'nt' | 'qld' | 'sa' | 'tas' | 'vic' | 'wa'
} & BaseElection

export type FederalElection = {
    type: 'federal'
} & BaseElection

export type Election = StateElection | FederalElection

/**
 * Returns the election id, provided an election object.
 * Used in the url as a slug.
 */
export const getElectionId = (election: Election) => {
    if (election.type === 'federal') {
        return `federal-election-${election.year}`
    } else {
        return `${election.state}-election-${election.year}`
    }
}
